import { createReducer } from '@reduxjs/toolkit';
import { getAllCompetenceTypes } from './actions';

const initialState = {
  list: [],
};

export default createReducer(initialState, builder =>
  builder.addCase(getAllCompetenceTypes, (state, action) => {
    state.list = action.payload;
  })
);
